import { Route } from 'react-router';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Page } from '@roc/feature-app-core';
import { LiquidityCalculator } from '@roc/client-portal-shared/modules/liquidityCalculator';
import { useRocInternalPortalStore } from '../../../hooks';

export const getLiquidityCalculatorInternalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    liquidityCalculator: {
      path: `${basePath}/liquidity-calculator`,
      url: `${baseUrl}/liquidity-calculator`,
      documentTitle: 'Liquidity Calculator',
    },
  };
};

export const getLiquidityCalculatorInternalRoutes = (
  basePath: string,
  baseUrl: string
) => {
  const config = getLiquidityCalculatorInternalRoutesConfig(basePath, baseUrl);
  const { liquidityCalculatorInternalStore } = useRocInternalPortalStore();

  return {
    liquidityCalculator: (
      <Route exact path={config.liquidityCalculator.path}>
        <Page routeDefinition={config.liquidityCalculator}>
          <LiquidityCalculator store={liquidityCalculatorInternalStore} />
        </Page>
      </Route>
    ),
  };
};
